import React from "react";
import TreeView from "./TreeView";

const TreeContainer = ({
  tree,
  onChange,
  handleSelectItem,
  onDoubleClick,
  onFocusOut,
  template,
  title,
}) => {
  return (
    <div style={{ display: "flex", gap: 20 }}>
      <TreeView
        title={title}
        data={tree}
        onDoubleClick={onDoubleClick}
        onFocusOut={onFocusOut}
        handleSelectItem={handleSelectItem}
        onChange={(updated) => onChange("tree", updated)}
        template={template}
      />
    </div>
  );
};

export default TreeContainer;
